import { GridColDef } from "@mui/x-data-grid";

const templateConfig: GridColDef[] = [
	{ field: 'id', headerName: 'Template ID', width: 200 },
	{ field: 'template_name', headerName: 'Template Name', width: 200 },
	{ field: 'hunt_group_name', headerName: 'Hunt Group Name', width: 200 },
	{ field: 'agency_name', headerName: 'Agency Name', width: 200 },
	{ field: 'client_name', headerName: 'Client Name', width: 200 },
	{ field: 'schedule_template_number', headerName: 'Schedule Template Number', width: 50},
	{ field: 'created_date', headerName: 'Created Date', width: 200},
	{ field: 'created_by', headerName: 'Created By', width: 200},
	{ field: 'updated_date', headerName: 'Updated Date', width: 200},
	{ field: 'updated_by', headerName: 'Updated By', width: 200}
];

export default templateConfig;